import { render } from "./About.vue?vue&type=template&id=068d4791"
const script = {}
script.render = render

export default script